<div [class]="class">

  <form [formGroup]="editModeFormGroup" class="label" role="heading" (ngSubmit)="$event.preventDefault()">
    <span class="legend" role="heading">{{label}}</span>
    <span class="lib-spacer"></span>

    <!-- firstInput -->
    <input
    class="lib-input"
    #firstInput
    formControlName="firstValue"
    [hidden]="!isEditModeEnabled"
    type="number"
    role="heading"
    (focus)="focus($event)"
    (keydown)="onKeyDown($event)"
    (blur)="blur($event)"
    [step]="stepValue"
    />
    <span [hidden]="isEditModeEnabled" [class.value]="!isDisabled" (click)="enterEditMode($event)">{{displayValue[0]}}</span>

    <!-- spacer -->
    <span [hidden]="!isArray">-</span>

    <!-- secondInput -->
    <input [hidden]="!isEditModeEnabled || !isArray || isDisabled"
    #secondInput
    formControlName="secondValue"
    class="lib-input"
    type="number"
    role="heading"
    (focus)="focus($event)"
    (keydown)="onKeyDown($event)"
    (blur)="blur($event)"
  
    [step]="stepValue"
    />
    <span [hidden]="isEditModeEnabled || !isArray" [class.value]="!isDisabled" (click)="enterEditMode($event, secondInput)">{{displayValue[1]}}</span>

    <lib-icon name="edit" (click)="enterEditMode($event)" [hidden]="isEditModeEnabled || isDisabled"></lib-icon>

  </form>

  <div class="slider" role="slider">
    <div #range role="slider"></div>
  </div>

</div>
